<hr>
<br><br>
<div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon card-header-rose">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">Edit Profile -
              <small class="category">Complete your profile</small>
            </h4>
          </div>
          <div class="card-body">
            <form (ngSubmit)="updateData()">
              <div class="d-flex justify-content-center">
                <div class="fileinput fileinput-new text-center" data-provides="fileinput">
                  <div class="text-gray">{{data.email}}</div>
                  <br>
                  <div class="fileinput-new thumbnail img-circle">
                    <img *ngIf="!data.picture" src="assets/dashboard/img/faces/avatar.jpg" alt="...">
                    <img *ngIf="data.picture" src="http://localhost:8000/{{data.picture}}" alt="...">
                  </div>
                  <div class="fileinput-preview fileinput-exists thumbnail img-circle"></div>
                  <div>
                          <span class="btn btn-round btn-rose btn-file">
                            <span class="fileinput-new">Update Photo</span>
                            <span class="fileinput-exists">Change</span>
                            <input type="file" name="image" (change)="handleFileInput($event.target.files)"/>
                          </span>
                    <br />
                    <a href="#pablo" class="btn btn-danger btn-round fileinput-exists" data-dismiss="fileinput"><i class="fa fa-times"></i> Remove</a>
                  </div>
                </div>
              </div>
              <br><br>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" class="form-control" name="first_name" placeholder="First Name..." [(ngModel)]="data.first_name">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" class="form-control" name="last_name" placeholder="Last Name..." [(ngModel)]="data.last_name">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <input type="text" class="form-control" name="address" [(ngModel)]="data.address" placeholder="address...">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="city..." [(ngModel)]="data.city" name="city">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="text" class="form-control" name="phone" [(ngModel)]="data.phone" placeholder="phone...">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="date" class="form-control" name="date_of_birth" [(ngModel)]="data.date_of_birth">
                  </div>
                </div>
              </div>
              <br><br><br><br>
              <button type="submit" class="btn btn-rose pull-right">Update Profile</button>
              <br><br><br>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-profile">
          <div class="card-avatar">
            <a href="#pablo">
              <img class="img" src="assets/dashboard/img/faces/marc.jpg" />
            </a>
          </div>
          <div class="card-body">
            <h6 class="card-category text-gray">CEO / Co-Founder</h6>
            <h4 class="card-title">Alec Thompson</h4>
            <p class="card-description">
              Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
            </p>
            <a href="#pablo" class="btn btn-rose btn-round">Follow</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
